import axios from 'axios'
import { API } from '../../constants/general'

export const Api = axios.create({
    baseURL: API
})

export async function GetApiToken({ token }: { token: string }) {
    try {
        const request = await Api.post('token', { token })

        return request.data
    } catch (error: any) {
        console.error(error)
        if (error.response && error.response.data.error) {
            return new Error(error.response.data.error)
        }
        return error
    }
}
